import { getConfig } from "@engaging-tech/ssr-config"

import { GET_WHW_SPONSORS } from "../../graphql/queries/sponsors.queries"
import { apollo } from "../../lib/Apollo"

const GRAPHQL_API_URL = () => `${getConfig().api.url}${getConfig().api.endpoints.graphql}`

export default async function getWhwSponsors() {
  return apollo.query({
    uri: GRAPHQL_API_URL,
    query: GET_WHW_SPONSORS
  })
}
